import React, { useEffect } from 'react'
import useEmbedHubSpotForm from 'hooks/useEmbedHubSpotForm'
import classnames from 'classnames/bind'
import LabelTitleText from 'components/shared/LabelTitleText'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const EmbedContactForm = ({
  className,
  formId,
  portalId,
  formIntro,
  isCompact,
}) => {
  useEmbedHubSpotForm({
    portalId,
    formId,
  })

  return (
    <>
      <div
        id="contact"
        className={cx(css.EmbedContactForm, className, {
          compact: isCompact,
        })}
      >
        {formIntro && (
          <LabelTitleText
            className={css.formIntro}
            titleProps={{
              size: 'small',
            }}
            center
            {...formIntro}
          />
        )}

        <div
          className={`hs-form-html form-${formId}`}
          data-form-id={formId}
          data-portal-id={portalId}
        ></div>
      </div>
    </>
  )
}

export default EmbedContactForm
